import React from "react";
import { CSVLink } from "react-csv";
import Button from "../../../components/CustomButton/CustomButton.jsx";

const DownloadProviderListButton = ({data, hasAdmin}) => {
  if (!hasAdmin || data.length === 0) return null;
  
  return (
    <div style={{ marginBottom: "1rem" }}>
      <CSVLink data={data} filename="providers.csv">
        <Button round fill>
          Download Provider List
        </Button>
      </CSVLink>
    </div>
  );
}

export default DownloadProviderListButton;
